<template>
  <el-dialog title="Gerar Boleto do Lançamento" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="375px">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="">
            <el-select v-model="form.geracao" style="width:100%;">
                <el-option label="Gerar Pdf" value="PDF"/>
                <el-option label="Enviar por e-mail" value="E_MAIL"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="form.geracao == 'E_MAIL'">
        <el-col :span="24">
          <el-form-item label="E-mail">
            <el-input v-model="form.email" auto-complete="off"/>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="gerarBoletoHandler" type="primary" size="small" v-if="form.geracao == 'PDF'" round class="btn-box-shadow">Gerar</el-button>
      <el-button @click="enviarBoletoHandler" type="primary" size="small" v-if="form.geracao == 'E_MAIL'" round class="btn-box-shadow">Enviar</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  props: {
    lancamento: Object,
    visibility: Boolean
  },
  data() {
    return {
        form: {
            geracao: "PDF",
            email: ""
        }
    }
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('contasReceberStore', [
        'gerarBoletoLancamento',
        'enviarBoletoLancamento'
    ]),
    gerarBoletoHandler() {
        this.showLoading();
        this.gerarBoletoLancamento(this.lancamento)
            .then(resultado => {
                switch(resultado.status) {
                    case "SUCESSO":
                        window.open(resultado.mensagem, "_blank");
                        break;
                    case "FALHA":
                        this.$message.warning(resultado.mensagem);
                        break;
                    case "ERRO":
                        this.$message.error(resultado.mensagem);
                }
                this.$emit('close');
            })
            .catch(() => {
                this.$message.error("Não foi possível comunicar-se com o servidor");
            })
            .finally(() => {
                this.hideLoading();
            });
    },
    enviarBoletoHandler() {
        this.showLoading();
        this.lancamento.email = this.form.email
        this.enviarBoletoLancamento(this.lancamento)
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.$message.success(resultado.mensagem);
                    break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
            this.$emit('close');
        }).catch(() => {
            this.hideLoading();
        });
    },
    reset(){
      this.form = {
            geracao: "PDF",
            email: ""
        }
    },
    fechar() {
      this.reset()
      this.$emit('close');
    }, 
  }
}
</script>
